module.exports = __webpack_public_path__ + "img/bz19.0d054ef1.svg";